module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO36Presupuesto.1f9cc0e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO36Presupuesto.mp4
// module id = 762
// module chunks = 1